import dayjs from "dayjs";

import { dynamicConfig } from "../../config";

const {
  availableTime: { from, to, step },
} = dynamicConfig;

export const availableTime = {
  from,
  to,
  step,
};

export const isAvailableTimeNow = () => {
  const now = dayjs();
  return now.isAfter(from) && now.isBefore(to);
};
